import type { RouteRecordRaw } from 'vue-router'

import HomePage from '../pages/HomePage.vue'
import ShopManagementPage from '../pages/ShopManagementPage.vue'

import { AppRoutes } from '@/enums/app-routes.enum.ts'

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang/home',
    component: HomePage,
    name: AppRoutes.HOME,
  },
  {
    path: '/:lang/team/:teamId/shop/:shopId/management',
    component: ShopManagementPage,
    name: AppRoutes.SHOP_MANAGEMENT,
  },
]

export default routes
